







import { Advertisement } from "@/interfaces/advertisement";
import { MediaObject } from "@/interfaces/mediaobject";
import Vue, { PropType } from "vue";
export default Vue.extend({
  props: {
    advertisement: Object as PropType<Advertisement>,
    inline: {
      default: false
    },
    label: {
      default: "号外ネットでプレビューする"
    }
  },
  methods: {
    click() {
      window.open("about:blank", "ggnetpreview", "width=1350, height=800");
      const form = this.$refs.form as HTMLFormElement;
      form.method = "post";
      if (!process.env.VUE_APP_PREVIEW_URL) {
        throw "preview url not set";
      }
      form.action = process.env.VUE_APP_PREVIEW_URL;
      //"https://goguy.castcube.co.jp/adv_preview";
      form.target = "ggnetpreview";
      form.innerHTML = "";
      const appendValue = (name: string, value: string | undefined) => {
        if (value) {
          const hidden = document.createElement("input");
          hidden.type = "hidden";
          hidden.name = name;
          hidden.value = value;
          form.appendChild(hidden);
        }
      };

      appendValue("title", this.advertisement.title + "【" + this.advertisement.storeName + "】");
      appendValue(
        "meta[advertisement_image1]",
        ((this.advertisement.image1 || {}) as MediaObject).contentUrl
          ? location.origin +
              ((this.advertisement.image1 || {}) as MediaObject).contentUrl
          : undefined
      );
      appendValue("meta[advertisement_body1]", this.advertisement.body1);
      appendValue(
        "meta[advertisement_image2]",
        ((this.advertisement.image2 || {}) as MediaObject).contentUrl
          ? location.origin +
              ((this.advertisement.image2 || {}) as MediaObject).contentUrl
          : undefined
      );
      appendValue("meta[advertisement_body2]", this.advertisement.body2);
      appendValue(
        "meta[advertisement_image3]",
        ((this.advertisement.image3 || {}) as MediaObject).contentUrl
          ? location.origin +
              ((this.advertisement.image3 || {}) as MediaObject).contentUrl
          : undefined
      );
      appendValue("meta[advertisement_body3]", this.advertisement.body3);
      appendValue(
        "meta[advertisement_image4]",
        ((this.advertisement.image4 || {}) as MediaObject).contentUrl
          ? location.origin +
              ((this.advertisement.image4 || {}) as MediaObject).contentUrl
          : undefined
      );
      appendValue("meta[advertisement_body4]", this.advertisement.body4);
      appendValue(
        "meta[advertisement_image5]",
        ((this.advertisement.image5 || {}) as MediaObject).contentUrl
          ? location.origin +
              ((this.advertisement.image5 || {}) as MediaObject).contentUrl
          : undefined
      );
      appendValue("meta[advertisement_body5]", this.advertisement.body5);

      appendValue("meta[advertisement_link1_url]", this.advertisement.link1Url);
      appendValue("meta[advertisement_link1_title]", this.advertisement.link1Title);
      appendValue("meta[advertisement_link2_url]", this.advertisement.link2Url);
      appendValue("meta[advertisement_link2_title]", this.advertisement.link2Title);
      appendValue("meta[advertisement_link3_url]", this.advertisement.link3Url);
      appendValue("meta[advertisement_link3_title]", this.advertisement.link3Title);

      appendValue("meta[advertisement_store_name]", this.advertisement.storeName);
      appendValue("meta[advertisement_store_address]", this.advertisement.storeAddress);
      appendValue("meta[advertisement_store_tel]", this.advertisement.storeTel);
      appendValue("meta[advertisement_business_hours]", this.advertisement.businessHours);
      appendValue("meta[advertisement_map_parameters]", this.advertisement.mapParameters);

      appendValue("meta[advertisement_homepage]", this.advertisement.homepage);

      form.submit();
    }
  }
});
